import { createFileRoute } from '@tanstack/react-router';

import { SettingsShell } from '@src/pages/Settings';

export const Route = createFileRoute('/app/settings')({
  component: SettingsShell,
});
